import {
  CheckFilterGroup, FacetCount,
  HierarchicFilterGroup,
  RangeGroup,
  RootSearchView,
  SearchViewPath
} from './search-objects';
import {SelectorContainer} from './selector-container';
import {SearchResult} from './search-result';
import {StoredSearch} from './stored-search';
import {SuperObjectModel} from './super-object-model';
import {SearchObject, SearchObjectRow} from './search-object';
import {SearchCategory} from './extended-search/search-category';
import {SearchSelections} from '../../object-search/search-selections';
import {QueryContainer} from '../query-container';
import {ExtendedSearchParams} from "./extended-search-params";

export class ScrollInfo {
  scrollElement: any;
  searchingScroll: boolean;
  searchingScrollDir: string;
}

export class SearchContainerBase {
  keepSelected: boolean;
  restrictions: any[];
  rows: any = {};
  searchPostFn: any;
  targetObject: SuperObjectModel;
  templateGroupId: string;
  listFieldTemplateId: string;
  refreshTemplateOverviewFields = false;
  toState: string;
  used: Array<string> = [];
  qOp: string;
}

export class SearchContainerParams extends SearchContainerBase {
  defaultCheckedFilters: object;
  filters: any;
  getStoredSearch: boolean;
  runSearch: boolean;
  selectedItems: Array<SearchObject> = [];
  searchViewName: string;
  searchViewData: RootSearchView = null;
  stateParams = {};
  targetState: string;
  useStoredSearch: boolean;
  qOp: string;
}

export class FiltersFacets {
  checkedFilters: object = {};
  facetCount: {[name: string]: FacetCount} = {};
  facetRangeGroups: Array<RangeGroup> = undefined;
  filterGroups: Array<CheckFilterGroup>;
  filtersChecked = 'notChecked';
  hierarchicFilterGroup: HierarchicFilterGroup;
}

export class StoredSearchContainer {
  curStoredSearch: StoredSearch;
  curStoredSearchId: string;
  curStoredSearchName: string;
  storedSearches: StoredSearch[];
  unchangedStoredSearches: StoredSearch[];
}

export class SearchContainer extends SearchContainerBase {
  $$searchContainerId: string = crypto.randomUUID();
  extendedSearchParams: ExtendedSearchParams;
  animateNewSearchResult = false;
  breadcrumbs: SearchObject[] = [];
  cachedScrollDataColumns: SearchObjectRow[];
  cachedScrollDataList: SearchObject[];
  combineHorizontal = true;
  storedSearch = new StoredSearchContainer();
  dbSearchCorrelationId?: string;
  currentPathView: SearchViewPath;
  displayAll = false;
  filtersFacets = new FiltersFacets();
  fetchedPages = new Set<number>();
  isFolderInfoOpen: boolean;
  maxPage: number;
  noFullSearch: boolean;
  object: any;
  objectCount: number;
  oldTempGroupId: string;
  operationContainer: any;
  operationContainerDropDown: any;
  private order: string = null;
  orderParentQuery: string = null;
  orderIsDefault = false;
  orderRandomSeed: string = '666';
  path: string = undefined;
  queryContainer = new QueryContainer();
  reportContainer: any;
  scrollInfo: ScrollInfo = new ScrollInfo();
  scrollToY = 20;
  searchCategory: SearchCategory;
  searchEngine: string;
  searching: boolean;
  searchItemIndex = 0;
  searchPage = 1;
  searchResultCallbacks: Array<any> = [];
  newScrollItemsCallback: any;
  searchResultViewName: string;
  searchResultViewDefaultSet = true;
  searchResultViews: { default: string, views: Array<any> };
  searchResult: SearchResult = undefined;
  searchRow: number;
  searchView: RootSearchView;
  selectButtonText: string;
  selections: SearchSelections = new SearchSelections();
  selectorContainer: SelectorContainer;
  state = {
    targetState: ''
  };
  targetId: string;
  totalSelectedFilters: number;
  toggleSortMenu: boolean;
  toggleActionMenu: boolean;
  virtualScrollEnabled = false;
  virtualScrollViewOffset: number;
  getTargetId = () => {
    return this.targetId;
  }

  setOrder(order: string, orderIsDefault: boolean, parentQuery?: string) {
    this.order = order;
    this.orderIsDefault = orderIsDefault;
    this.orderParentQuery = parentQuery;
  }

  getOrder() {
    return this.order;
  }
}
